// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--TZ_K2","aside":"_7a3fb80146--aside--KIolj","close":"_7a3fb80146--close--rUUEO"};